import Vue from 'vue'

import VueYouTubeEmbed, { getIdFromURL } from 'vue-youtube-embed'

Vue.prototype.$getYoutubeIdv = getIdFromURL

Vue.use(VueYouTubeEmbed, { global: true })
